import { DataChannel } from './channel';
import { SurveyLinksUpdateResponse } from '../../overview/target-group/target-group-setup.component';
import { SurveyLinksDialogResult } from '../target-group/survey-links/survey-links-dialog.component';

export const surveyLinksChannel = {
  result: new DataChannel<SurveyLinksDialogResult>(),
  updated: new DataChannel<SurveyLinksUpdateResponse>(),
};
